import type { KpiCard as KpiCardData } from "../api.ts";
import { changeClass, fmtPct } from "../lib/format.ts";
import { Sparkline } from "./charts/index.ts";

interface Props {
  label: string;
  data: KpiCardData;
  format: (n: number) => string;
  inverseGood?: boolean;
  unit?: string;
  /** Série de N pontos pra sparkline mini-chart. Opcional. */
  sparkline?: number[];
}

export function KpiCard({ label, data, format, inverseGood = false, unit, sparkline }: Props) {
  const cls = changeClass(data.change_pct, inverseGood ? "negative-good" : "positive-good");
  const arrow = cls === "up" ? "↑" : cls === "down" ? "↓" : "→";
  return (
    <div className="kpi-card">
      <div className="label">{label}</div>
      <div className="value">
        {format(data.current)}
        {unit && <small>{unit}</small>}
      </div>
      <div className="meta">
        {data.change_pct !== null && (
          <span className={`change ${cls}`}>{arrow} {fmtPct(data.change_pct, false)}</span>
        )}
        <span>vs mês anterior</span>
        {data.target !== null && (
          <span className="target">· meta {format(data.target)}</span>
        )}
      </div>
      {sparkline && sparkline.length > 1 && (
        <div style={{ marginTop: ".7rem", marginLeft: "-4px", marginRight: "-4px" }}>
          <Sparkline data={sparkline} height={32} trend={inverseGood ? "down" : "up"} />
        </div>
      )}
    </div>
  );
}
